import { useMutation } from '@tanstack/react-query';

import type { AuthCustomer } from '@getjust/api-schema';

import { usePrelude } from '$hooks/client';
import { authAPI } from '$src/http';

export const MUTATION_VERIFY_PHONE_KEY = 'MUTATION/VERIFY_PHONE';

export interface VerifyPhoneParams {
  phoneNumber: string;
}

export interface VerifyPhoneResult {
  outcome: 'initiated' | 'failed';
  method?: AuthCustomer.VerificationMethod;
  requestUrl?: string;
  error?: string;
}

export const useVerifyPhone = () => {
  const { dispatchId, isPreludeEnabled } = usePrelude();

  return useMutation({
    mutationFn: async (params: VerifyPhoneParams): Promise<VerifyPhoneResult> => {
      const payload: AuthCustomer.VerifyPhoneRequestBody = {
        phoneNumber: params.phoneNumber,
        // Include Prelude dispatchId if available for silent verification
        ...(isPreludeEnabled && dispatchId ? { dispatchId } : {}),
      };

      const { data } = await authAPI.post<AuthCustomer.VerifyPhoneResponseBody>(
        '/verify-phone',
        payload,
      );

      return data;
    },
    mutationKey: [MUTATION_VERIFY_PHONE_KEY],
  });
};

